import config from '../config';

const appConfig = config();
const { v2 } = appConfig.apiVersion;
const { apiPrefix } = appConfig;

export default class GroupCompanyService {
  constructor(client) {
    this.client = client;
  }

  async getGroupCompanies({ companyId }) {
    const response = await this.client.get(
      `${apiPrefix}${v2}/companies/${companyId}/group-companies`
    );
    return response.data;
  }
}
